/* ═══════════════════════════════════════
   ICEBERRY JEWELLERY — Theme JS v41
   ═══════════════════════════════════════ */

// ── Add to Cart (AJAX) mit Optimistic UI ──
async function addToCart(event, variantId) {
  event.preventDefault();
  event.stopPropagation();

  const btn = event.currentTarget;
  const originalText = btn.textContent;

  btn.textContent = '✓ Hinzugefügt';
  btn.style.background = 'var(--gold)';
  btn.disabled = true;

  try {
    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (response.ok) {
      updateCartCount();
      setTimeout(() => {
        btn.textContent = originalText;
        btn.style.background = '';
        btn.disabled = false;
      }, 1800);
    } else {
      throw new Error('Cart error');
    }
  } catch (err) {
    btn.textContent = originalText;
    btn.style.background = '';
    btn.disabled = false;
    btn.classList.add('shake');
    setTimeout(() => btn.classList.remove('shake'), 500);
  }
}

// ── Update cart count badge ──
async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const badge = document.querySelector('.cart-count');
    const cartBtn = document.querySelector('.cart-btn');

    if (cart.item_count > 0) {
      if (badge) {
        badge.textContent = cart.item_count;
        badge.setAttribute('aria-live', 'polite');
      } else if (cartBtn) {
        const span = document.createElement('span');
        span.className = 'cart-count';
        span.textContent = cart.item_count;
        span.setAttribute('aria-live', 'polite');
        cartBtn.appendChild(span);
      }
      if (cartBtn) {
        cartBtn.classList.add('bounce-animation');
        setTimeout(() => cartBtn.classList.remove('bounce-animation'), 500);
      }
    } else if (badge) {
      badge.remove();
    }
  } catch (err) {
    console.error('Cart count error:', err);
  }
}

// ── Varianten-Preis Update ──
function updateVariantPrice(select) {
  const selected = select.options[select.selectedIndex];
  const price = selected.getAttribute('data-price');
  const priceEl = document.getElementById('product-price');
  if (priceEl && price) {
    priceEl.textContent = price;
  }
  // Sticky Cart Button Preis auch aktualisieren
  const stickyBtn = document.querySelector('.sticky-cart-btn');
  if (stickyBtn && price) {
    stickyBtn.textContent = `In den Warenkorb — ${price}`;
  }
}

// ── Thumbnail Active State ──
function setActiveThumbnail(clickedEl) {
  document.querySelectorAll('.thumb-wrapper').forEach(t => {
    t.style.opacity = '0.6';
    t.style.outline = 'none';
  });
  clickedEl.style.opacity = '1';
  clickedEl.style.outline = '2px solid var(--gold)';
  clickedEl.style.outlineOffset = '2px';
}


// ── Mobile Nav ──
// closeNav + openNav global damit onclick-Handler in header.liquid sie erreichen koennen
let _navIsOpen = false;

function openNav() {
  const burger = document.getElementById('navBurger');
  const navMobile = document.getElementById('navMobile');
  const navOverlay = document.getElementById('navOverlay');
  if (!burger || !navMobile) return;
  _navIsOpen = true;
  burger.classList.add('open');
  navMobile.classList.add('open');
  if (navOverlay) navOverlay.classList.add('open');
  document.body.style.overflow = 'hidden';
  burger.setAttribute('aria-label', 'Menü schließen');
}

function closeNav() {
  const burger = document.getElementById('navBurger');
  const navMobile = document.getElementById('navMobile');
  const navOverlay = document.getElementById('navOverlay');
  if (!burger || !navMobile) return;
  _navIsOpen = false;
  burger.classList.remove('open');
  navMobile.classList.remove('open');
  if (navOverlay) navOverlay.classList.remove('open');
  document.body.style.overflow = '';
  burger.setAttribute('aria-label', 'Menü öffnen');
}

function initNav() {
  const burger = document.getElementById('navBurger');
  if (!burger) return;
  burger.addEventListener('click', () => _navIsOpen ? closeNav() : openNav());
}


const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('revealed');
      revealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });

// ── Footer Akkordeon ──
// FIX: offsetHeight wird VOR jeder Style-Mutation gelesen → kein Layout Thrash
function toggleFooterCol(id) {
  if (window.innerWidth > 600) return;
  const col = document.getElementById(id);
  if (!col) return;
  const content = col.querySelector('.footer-col-content');
  const chevron = col.querySelector('.footer-chevron');
  const isOpen = col.classList.contains('footer-open');

  if (isOpen) {
    content.style.transform = 'scaleY(0)';
    content.style.opacity = '0';
    chevron.style.transform = 'rotate(0deg)';
    col.classList.remove('footer-open');
    setTimeout(() => {
      if (!col.classList.contains('footer-open')) {
        content.style.height = '0';
      }
    }, 300);
  } else {
    // KRITISCH: Höhe lesen BEVOR irgendwelche Styles gesetzt werden
    // Verhindert Forced Layout Reflow (war 1.604ms Blockierung)
    content.style.height = 'auto';
    content.style.visibility = 'hidden';
    content.style.transform = 'scaleY(1)';
    const h = content.offsetHeight; // ← jetzt sauber: kein DOM-State-Konflikt
    content.style.visibility = '';
    content.style.transform = 'scaleY(0)';
    content.style.opacity = '0';
    content.style.height = h + 'px';

    requestAnimationFrame(() => {
      requestAnimationFrame(() => { // doppeltes rAF für garantierten Style-Flush
        content.style.transform = 'scaleY(1)';
        content.style.opacity = '1';
      });
    });
    chevron.style.transform = 'rotate(180deg)';
    col.classList.add('footer-open');
  }
}

function initFooterMobile() {
  const cols = document.querySelectorAll('.footer-col-content');
  const chevrons = document.querySelectorAll('.footer-chevron');
  const isMobile = window.innerWidth <= 600;

  if (isMobile) {
    cols.forEach(c => {
      c.style.height = '0';
      c.style.transform = 'scaleY(0)';
      c.style.opacity = '0';
    });
    chevrons.forEach(c => { c.style.display = 'block'; });
    document.querySelectorAll('.footer-col').forEach(c => c.classList.remove('footer-open'));
  } else {
    cols.forEach(c => {
      c.style.height = '';
      c.style.transform = '';
      c.style.opacity = '';
    });
    chevrons.forEach(c => { c.style.display = 'none'; });
  }
}

// ── Announcement Bar Rotation ──
// FIX: aus inline <script> in section herausgelöst → kein render-blocking
function initAnnouncementBar() {
  const items = document.querySelectorAll('.ann-item');
  if (!items.length) return;
  let current = 0;
  setInterval(() => {
    items[current].classList.remove('active');
    current = (current + 1) % items.length;
    items[current].classList.add('active');
  }, 3000);
}

// ── DOMContentLoaded – ein einziger Listener ──
document.addEventListener('DOMContentLoaded', () => {

  // Nav initialisieren (war inline script in header.liquid)
  initNav();

  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

  // Cart count – nur fetchen wenn Badge sichtbar (spart Request bei leerem Cart)
  if (document.querySelector('.cart-count')) {
    updateCartCount();
  }

  // Scroll Reveal
  const revealEls = document.querySelectorAll(
    '.prod-card, .cat-card, .mat-card, .review-card, .craft-pt, .care-card'
  );
  revealEls.forEach((el, i) => {
    el.style.opacity = '0';
    el.style.transform = 'translateY(18px)';
    el.style.transition = `opacity 0.5s ease ${(i % 4) * 0.06}s, transform 0.5s ease ${(i % 4) * 0.06}s`;
    revealObserver.observe(el);
  });

  // Announcement Bar
  initAnnouncementBar();

  // Footer – alles über requestIdleCallback (nicht kritisch für First Paint)
  const initFooter = () => {
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(initFooterMobile, 150);
    });
    initFooterMobile();
  };

  if ('requestIdleCallback' in window) {
    requestIdleCallback(initFooter);
  } else {
    setTimeout(initFooter, 200);
  }
});
